import React from "react";
import Typography from '@mui/material/Typography';
import './Experience.scss';
import Timeline from "../Timeline/Timeline";

const Experience = () => {

    return (
        <div id="experience">

            <div className="container">

                <Typography variant="h3" gutterBottom component="div" className="text-center main-heading">
                    Experience
                </Typography>
                <Typography variant="h6" gutterBottom component="div" className="text-center mini-heading">
                    Some of the experiences I have gained
                </Typography>

                <Timeline />
            </div>
        </div>
    );
}

export default Experience;